import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation, useNavigate } from "react-router-dom";
import { storage } from "../utils/storage.js";
import { handleAndShowError, showError } from "../utils/errorHandler.js";
import { ERROR_MESSAGES } from "../constants/constants.js";
import api from "../api/client.js";
import { ENDPOINTS } from "../api/endpoints.js";
import { typography } from "../styles/utils/typography";

const useStyles = () => ({
  textField_ID: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  textField_PW: {
    marginBottom: "8px",
  },
  button: {
    marginTop: "16px",
    width: "100%",
    height: "45px",
    backgroundColor: "#5EB3D7",
    color: "#ffffff",
    "&:focus": {
      backgroundColor: "#5EB3D7",
    },
  },
  backdrop: {
    zIndex: 1252,
    color: "#fff",
  },
});

function Sso() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let user_id = new URLSearchParams(location.search).get("id");
    let userPass = new URLSearchParams(location.search).get("pw");

    if (user_id === undefined || userPass === undefined) {
      navigate("/", {
        replace: true,
      });
      return;
    }

    let form = new FormData();
    form.append("id", user_id);
    form.append("pass", userPass);

    api
      .post(ENDPOINTS.LOGIN, form, {
        skipErrorHandler: true, // Sso에서 직접 에러 처리
      })
      .then((responseData) => {
        if (responseData.code === "0") {
          if (responseData.PROGRAM.length === 0) {
            showError(ERROR_MESSAGES.NO_PROGRAM_PERMISSION, "warning");
          } else {
            // 세션 스토리지에 로그인 정보 저장
            storage.setUserId(responseData.DATA.USER_ID);
            storage.setUserName(responseData.DATA.USER_NAME);
            storage.setWorkplaceCd(responseData.DATA.CUST_CD);
            storage.setWorkplaceNm(responseData.DATA.CUST_NAME);
            storage.setTelNo(responseData.DATA.TEL_NO);
            storage.setEmail(responseData.DATA.E_MAIL);
            storage.setSellCustCd(responseData.DATA_CUSTOM);
            storage.setCodeNm(responseData.CODE_NM);
            storage.setCodeStan(responseData.CODE_STAN);
            storage.setYardCustCd(responseData.CODE_YARD_CUST_CD || []);
            storage.setNameCd(responseData.CODE_NM || []);
            storage.setTypeCd(responseData.CODE_TYPE_CD || []);
            storage.setStanCd(responseData.CODE_STAN || []);
            storage.setSellCustCd(responseData.CODE_SELL_CUST_CD || []);
            storage.setVenCustCd(responseData.CODE_VEN_CUST_CD || []);
            storage.setJobCustCd(responseData.CODE_JOB_CUST_CD || []);
            storage.setProcPlantCd(responseData.CODE_PLANT_CD || []);
            storage.setProgram(responseData.PROGRAM);
            navigate("/home", {
              replace: true,
              state: { program: responseData.PROGRAM },
            });
          }
        } else {
          showError(responseData.RESULT_MESSAGE, "error");
          navigate("/", {
            replace: true,
          });
        }
      })
      .catch((e) => {
        handleAndShowError(e, "SSO 로그인 중 오류가 발생했습니다.");
        navigate("/", {
          replace: true,
        });
      });
  }, [location.search, navigate]);

  return (
    <Box className="tab-root">
      <Box
        sx={{
          width: "100%",
          height: "100%",
          padding: "6px 8px",
          boxSizing: "border-box",
          backgroundColor: "oklch(92% 5% 206.382)",
          borderRadius: "14px",
        }}
      >
        <Backdrop sx={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            textAlign: "center",
            color: "oklch(25% 10% 260)",
          }}
        >
          <Box
            sx={{
              width: "64mm",
              display: "flex",
              flexDirection: "column",
              margin: "64px auto",
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-46%, -50%)",
          fontSize: "1.7rem",
          fontWeight: typography.fontWeight.bold,
          letterSpacing: "0",
        }}
      >
        로그인정보를 확인중입니다...
      </Box>
      <Box
        component="img"
        src={process.env.PUBLIC_URL + "/images/micromos.png"}
        sx={{
          position: "absolute",
          top: "18px",
          left: "18px",
          width: "36mm",
          margin: "0 auto",
        }}
      />
    </Box>
  );
}

export default Sso;
